import $ from "jquery"
import { smoothScrollToID } from "./smoothSroll"

const seeMoreButton = () => {
    $(".section-landing-features__see-more").find("button").click(function() {
        $(".section-landing-features__table").addClass("openned")
        $(this).hide()
    })
}

const showOnlyFeaturesMissingOnJamf = () => {
    const jamfClass = ".section-landing-features__table-value-jamf-action"
    $(jamfClass).click(function() {
        const button = $(this)
        button.toggleClass("active")
        const isActive = button.hasClass("active")

        $(".section-landing-features__table-row").each(function(index, element) {
            // first element always needs to be shown
            if (index > 1) {
                const isMissing = $(element).hasClass("missing-on-jamf-feature")
                if (!isMissing && isActive) $(element).hide()
                else $(element).show()
            }
        })
    })
}

const userRegistration = () => {
    const form = $(".section-promo__form").find("form")
    const email = $("#email-promo")
    const firstName = $("#first-name-promo")
    const lastName = $("#last-name-promo")
    let terms = true
    const type = "organization";
    const password1 = $("#password1-promo")
    const password2 = $("#password2-promo")

    const messagesContainer = $(".section-promo__form-messages")

    form.submit(function(e) {
        e.preventDefault()

        validate()

        if (isValid()) {
            $(document.body).addClass("loading")
            $.post(window.location.origin+"/user/signup/", {
                    first_name: firstName.val(),
                    last_name: lastName.val(),
                    email: email.val(),
                    type: type,
                    password1: password1.val(),
                    password2: password2.val(),
                })

                .done(function (data) {
                    $(document.body).removeClass("loading")
                    let userEmail = $(".signup-success-modal").find(".signup__result-text .signup__link");
                    userEmail.text(email.val())
                    userEmail.attr("href", `mailto:${email.val()}`)
                    messagesContainer.find(".messages").remove()
                    $(".signup__result-resend-email").attr("href", data.resend_activation_email_url_marketing)
                    $(".signup-success-modal").addClass("modal--open")
                    $(document.body).addClass("modal-active")
                })
                .fail(function (data) {
                    $(document.body).removeClass("loading")
                    if (!data.responseJSON.success) {
                        let txt = `<p class="messages messages-danger">${data.responseJSON.message}</p>`

                        if (data.responseJSON.message.password1) {
                            txt = `<p class="messages messages-danger">${data.responseJSON.message.password1[0]}</p>`
                        }

                        if (data.responseJSON.message.password2) {
                            txt = `<p class="messages messages-danger">${data.responseJSON.message.password2[0]}</p>`
                        }

                        if (data.responseJSON.message.email) {
                            txt = `<p class="messages messages-danger">${data.responseJSON.message.email[0]}</p>`
                        }

                        messagesContainer.html(txt)
                    }
                })
        }

    })

    $("#signup-agreement-promo").on("change", function() {
        terms = $(this).is(":checked")
    })

    function validate () {
        if (email.val().length <= 0) email.parents(".input").addClass("error")
        else email.parents(".input").removeClass("error")

        if (firstName.val().length <= 0) firstName.parents(".input").addClass("error")
        else firstName.parents(".input").removeClass("error")

        if (lastName.val().length <= 0) lastName.parents(".input").addClass("error")
        else lastName.parents(".input").removeClass("error")

        if (password1.val().length < 9) {
            password1.parents(".input").addClass("error")
            messagesContainer.html(errorMessage("Password must be alphanumeric and at least 9 characters long"))
        }
        else password1.parents(".input").removeClass("error")

        if (password1.val() != password2.val()) {
            password2.parents(".input").addClass("error")
            messagesContainer.html(errorMessage("Passwords do not match"))
        }
        else password2.parents(".input").removeClass("error")

        let checkbox = $("#signup-agreement-promo")[0]
        checkbox.setCustomValidity(terms ? "" : "Please indicate that you accept the Terms and Conditions")
    }

    function isValid () {
        return email.val().length > 0 && firstName.val().length > 0 && lastName.val().length > 0 &&
            terms && password1.val().length >= 9 && password1.val() == password2.val()
    }

    function errorMessage (message) {
        return `<p class="messages messages-danger">${message}</p>`
    }
}

const moveToTopOnTryForFreeButtonClick = () => {
    const isLandingPage = $(document.body).hasClass("landing-pages")

    if (isLandingPage) {
        $(".signup-personal1").click(scrollToToTop)
        $(".signup-organization1").click(scrollToToTop)
        function scrollToToTop(e) {
            e.preventDefault()
            $("html, body").animate({
                scrollTop: 0
            }, 1000);
        }
    }

}

const validateForm = () => {
    const form = $(".section-promo__right-form")
    const fName = form.find("[name='first-name']")
    const lName = form.find("[name='last-name']")
    const email = form.find("[name='email']")

    form.submit(function(e) {
        e.preventDefault()
        if (fName.val().length > 0 && lName.val().length > 0 && email.val().length) {
            const url = `https://${window.location.hostname}/en/?signup=true`
            window.location = url
            // form.unbind().submit()
        }

        if (fName.val().length <= 0) showError(fName)
        else removeError(fName)

        if (lName.val().length <= 0) showError(lName)
        else removeError(lName)

        if (email.val().length <= 0) showError(email)
        else removeError(email)
    })

    function showError(el) {
        el.parents(".input").addClass("error")
    }

    function removeError(el) {
        el.parents(".input").removeClass("error")
    }
}

const overrideFeatureNavigation = () => {
    var urlParams = new URLSearchParams(window.location.search);
    const feature_element = $(".landing-section-tracking")

    if (urlParams.has("to") && urlParams.get("to") == "feature") {
        $('html, body').animate({
            scrollTop: feature_element.offset().top - 60
        }, 2000);
    } else {
        const feature_link = $("#feature-navigation-link")
        const link = feature_link.attr("href")
        feature_link.click(function (e) {
            e.preventDefault()
            let header_mobile_button = $(".site-header__mobule-button")
            if (header_mobile_button.css("display") != "none") {
                header_mobile_button.click()
            }
            // $(".site-header__mobule-button").click()
            if (window.location.pathname !== link) {
                window.location.href = `${link}?to=feature`
            } else {
                $('html, body').animate({
                    scrollTop: feature_element.offset().top - 60
                }, 2000);
            }
        })
    }
}

export const landingPageInit = () => {
    $(document).ready(function() {
        seeMoreButton()
        showOnlyFeaturesMissingOnJamf()
        moveToTopOnTryForFreeButtonClick()
        validateForm()
        // overrideFeatureNavigation()
    })
}
